module.exports = __webpack_public_path__ + "img/ico_ai.3351f57.gif";